import { Reveal, Overline } from "@/components/Kinetic";
import { useLang } from "@/i18n/LanguageContext";

const PRINCIPLES_EN = [
  {
    index: "01",
    title: "Problem first",
    text: "Every product starts from a concrete operational or commercial problem — not from a technology looking for a use case.",
  },
  {
    index: "02",
    title: "AI where it matters",
    text: "We apply AI where reasoning, research, classification or automation creates meaningful value. Never as decoration.",
  },
  {
    index: "03",
    title: "Engineering with ownership",
    text: "We build to operate, improve and maintain — from our own products to selected digital initiatives.",
  },
  {
    index: "04",
    title: "Built for real workflows",
    text: "Software should fit the way businesses actually operate — not the other way around.",
  },
];

const PRINCIPLES_TR = [
  {
    index: "01",
    title: "Önce problem",
    text: "Her ürün somut bir operasyonel veya ticari problemden başlar — kullanım alanı arayan bir teknolojiden değil.",
  },
  {
    index: "02",
    title: "Gerektiği yerde yapay zekâ",
    text: "Yapay zekâyı yalnızca akıl yürütme, araştırma, sınıflandırma veya otomasyonun anlamlı değer yarattığı yerde kullanırız. Asla süs olarak değil.",
  },
  {
    index: "03",
    title: "Sahiplenerek geliştirme",
    text: "Kendi ürünlerimizde ve seçili dijital çalışmalarımızda yazılımı işletmek, geliştirmek ve sürdürmek için tasarlarız.",
  },
  {
    index: "04",
    title: "Gerçek iş akışları için",
    text: "Yazılım, işletmelerin gerçekte çalıştığı biçime uymalıdır — tersi değil.",
  },
];

export default function WhyGadulabs() {
  const { lang, tx } = useLang();
  const principles = lang === "tr" ? PRINCIPLES_TR : PRINCIPLES_EN;

  return (
    <section
      id="why"
      data-testid="why-gadulabs-section"
      className="border-t border-slate-200 bg-paper py-20 sm:py-28 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Overline>{tx("Why GADULABS", "Neden GADULABS")}</Overline>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-ink sm:text-4xl">
            {tx(
              "We build software around real problems.",
              "Gerçek sorunların etrafında yazılım geliştiriyoruz.",
            )}
          </h2>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((p, i) => (
            <Reveal key={p.index} delay={i * 0.08} y={22}>
              <div
                data-testid={`principle-${p.index}`}
                className="border-t-2 border-ink pt-6"
              >
                <span className="font-mono text-xs tracking-[0.15em] text-slate-400">
                  {p.index}
                </span>
                <h3 className="mt-3 font-display text-lg font-bold tracking-tight text-ink">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {p.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
